import React from 'react'
import { Controller } from 'react-hook-form'
import {
  Grid,
  MenuItem,
  Select as SelectMain,
  FormControl,
  InputLabel,
} from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 120,
  },
}))

const StateTextField = ({ input, control, setValue }) => {
  const classes = useStyles()

  return (
    <Grid
      item
      xs={input?.width[0] || 12}
      sm={input?.width[1] || 12}
      md={input?.width[2] || 12}
      lg={input?.width[3] || 12}
      key={input.id}
    >
      <Controller
        name={input.name}
        control={control}
        defaultValue=""
        as={
          <FormControl
            variant={input.field.variant}
            className={classes.formControl}
            size="small"
            fullWidth
          >
            <InputLabel>{input?.labelName}</InputLabel>
            <SelectMain
              label={input?.labelName}
              required={input.field.required}
              defaultValue=""
              onChange={(event) => {
                setValue(input.name, event.target.value)
              }}
            >
              {input.options.map((option, index) => (
                <MenuItem key={index} value={option}>
                  {option}
                </MenuItem>
              ))}
            </SelectMain>
          </FormControl>
        }
      />
    </Grid>
  )
}

export default StateTextField
